module.exports = __webpack_public_path__ + "img/value-blocks-slider-toyota.a4b22775.png";